var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGpsConnected = function SvgGpsConnected(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6285_126295)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 8.97827,
    r: 5.76733,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 20.7055C7.31671 18.4221 5.31269 16.3011 3.98802 14.3424C2.66267 12.3844 2 10.5721 2 8.90539C2 6.40537 2.80434 4.41369 4.41302 2.93034C6.02103 1.44699 7.88338 0.705322 10.0001 0.705322C12.1167 0.705322 13.9794 1.44699 15.5881 2.93034C17.1961 4.41369 18.0001 6.40537 18.0001 8.90539C18.0001 10.5721 17.3375 12.3844 16.0121 14.3424C14.6874 16.3011 12.6834 18.4221 10.0001 20.7055Z",
    fill: "#09B965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.165 6.70605C12.2934 6.57763 12.4617 6.51343 12.6299 6.51343C12.7981 6.51343 12.9663 6.57763 13.0947 6.70605C13.3516 6.96287 13.3516 7.37893 13.0947 7.63575L9.47993 11.2506C9.35152 11.379 9.1833 11.4432 9.01508 11.4432C8.84686 11.4432 8.67864 11.379 8.55023 11.2506L6.90526 9.60688C6.64844 9.35005 6.64844 8.934 6.90526 8.67717C7.16209 8.42035 7.57815 8.42035 7.83497 8.67717L9.01508 9.856L12.165 6.70605Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6285_126295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.705322)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGpsConnected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "gps-connected.0b6a60241f25b7261c9a2460f3169f1f.svg";